/** Where a person lands: their one run, or the run they opened last on this device; with several and none remembered, the list of their runs (shell/runs.ts). */
import type { Principal } from "@bsim/contracts";
import { chosenRun, RUNS_PATH, runPath } from "./runs";

export { welcomedKey } from "./runs";

export function landingPath(principal: Principal): string | null {
  if (principal.memberships.length === 0) return null;
  const run = chosenRun(principal);
  return run === null ? RUNS_PATH : runPath(run, principal.memberships.length > 1);
}
